import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { ButtonComponent } from './button/button.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { BreadcrumbBarComponent } from './breadcrumb-bar/breadcrumb-bar.component';
import { InnerButtonComponent } from './button/inner-button/inner-button.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IframeDialogModule } from '../../site-container/iframe-dialog/iframe-dialog.module';

@NgModule({
    declarations: [
        NavBarComponent,
        FooterComponent,
        ButtonComponent,
        SearchBarComponent,
        BreadcrumbBarComponent,
        InnerButtonComponent,
    ],
    imports: [CommonModule, RouterModule, MatIconModule, MatMenuModule, MatSelectModule, MatAutocompleteModule, FormsModule, ReactiveFormsModule, MatInputModule, IframeDialogModule, MatDialogModule],
    exports: [
        NavBarComponent,
        FooterComponent,
        ButtonComponent,
        SearchBarComponent,
        BreadcrumbBarComponent,
    ],
})
export class GlobalUIComponentsModule { }
